<template>
  <div id="app">

    <router-view v-slot="{ Component }">
      <transition name="page" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>

  </div>
</template>

<script>
import "bootstrap-icons/font/bootstrap-icons.css";

export default {
  name: "App",
};
</script>

<style>

#app {
  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* PAGE TRANSITION */

.page-enter-active,
.page-leave-active {
  transition: opacity 0.35s ease, transform 0.35s ease;
}

.page-enter-from {
  opacity: 0;
  transform: translateY(25px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-25px);
}

</style>